import type { ApplicationProfileDto } from "../../types/ApplicationProfileDto";
import type { ApplicationProfileEntity } from "../../types/ApplicationProfileEntity";

export const ApplicationProfileDtoToEntity = ({ ...rest }: Readonly<ApplicationProfileDto>): ApplicationProfileEntity => {
    return { ...rest };
};
